const IMAGES = {
  DIGIT_DARK: "https://egov-dev-assets.s3.ap-south-1.amazonaws.com/digit.png",
  DIGIT_LIGHT:
    "https://egov-uat-assets.s3.ap-south-1.amazonaws.com/hcm/mseva-white-logo.png",
  DIGIT_FOOTER_DARK:"https://unified-dev.digit.org/egov-dev-assets/digit-footer-bw.png",
  DIGIT_FOOTER_LIGHT:"https://unified-dev.digit.org/egov-dev-assets/digit-footer.png"
};

export { IMAGES };
